import React from 'react'

import { Flex, PageSection2 } from '@guiker/react-framework'
import { NEWProperty } from '@guiker/real-estate-shared'

import { useT } from '../../i18n'
import { Document } from '../Document'

type ListingDocumentsProps = {
  property: NEWProperty
}

export const ListingDocuments: React.FC<ListingDocumentsProps> = ({ property }) => {
  const { tMain } = useT({ screenName: 'screens.listingScreen.tab1.sections.listingDocuments' })
  const propertyDocuments = property.documents

  return (
    <PageSection2 title={tMain('header')}>
      {propertyDocuments?.length > 0 && (
        <Flex flexDirection='column' gap={3} maxWidth={700} width='100%'>
          {propertyDocuments.map((document) => (
            <Document key={document.id} url={document.url} displayName={document.displayName ?? document.fileName} />
          ))}
        </Flex>
      )}
    </PageSection2>
  )
}
